import type { HelpWidgetConversation } from "@/react/components/HelpWidget/types/help_widget_conversation";
import { absolutePath } from "./absolutePath";

interface SupportWidgetFnProps {
  conversation?: HelpWidgetConversation;
  conversationFilters?: {
    channel_type: "all" | "circle_bot" | "live_chat" | "email";
    status: "all" | "draft" | "closed" | "solved" | "open";
  };
  flow?: Record<string, unknown>;
  id?: string | number;
  params?: Record<string, unknown>;
  searchText?: string | number;
  spaceId?: string | number;
  target?: string;
  zendeskUploadId?: string | number;
}

export const supportWidget = {
  listTutorialPosts: () => absolutePath("support_widget/home"),
  listPosts: ({ spaceId, searchText }: SupportWidgetFnProps) =>
    absolutePath("support_widget/posts", {
      space_id: spaceId || "",
      search_text: searchText || "",
    }),
  listNews: () => absolutePath("support_widget/news"),
  showPost: ({ id }: SupportWidgetFnProps) =>
    absolutePath(`support_widget/posts/${id}`),
  showPinnedPost: () => absolutePath(`support_widget/home/pinned_post`),
  spaceGroups: () => absolutePath("support_widget/space_groups"),
  createConversation: () => absolutePath("support_widget/conversations"),
  listConversations: () => absolutePath("support_widget/conversations"),
  showConversation: ({ id }: SupportWidgetFnProps) =>
    absolutePath(`support_widget/conversations/${id}`),
  updateConversation: ({ id }: SupportWidgetFnProps) =>
    absolutePath(`support_widget/conversations/${id}`),
  createAttachment: () => absolutePath("support_widget/attachments"),
  checkAttachment: ({ zendeskUploadId, target }: SupportWidgetFnProps) =>
    absolutePath(`support_widget/attachments/${zendeskUploadId}/check`, {
      target: target || "",
    }),
  createPostFeedback: () => absolutePath("support_widget/post_feedbacks"),
  listEvents: () => absolutePath("support_widget/events"),
  createChatMessage: () => absolutePath("support_widget/chats"),
  createLiveChatMessage: () => absolutePath("support_widget/live_chats"),
  downloadChat: (id: SupportWidgetFnProps["id"]) =>
    absolutePath(`support_widget/chats/${id}/download`),
  completeOnboarding: () =>
    absolutePath("support_widget/onboardings/mark_as_completed"),
  uploadLiveChatAttachment: () =>
    absolutePath("support_widget/live_chats/upload"),
  getLiveChatStatus: ({ flow }: SupportWidgetFnProps = {}) =>
    absolutePath("support_widget/live_chats/status", { flow }),
};
